import { useEffect } from 'react';
import { identify, init } from '@fullstory/browser';
import { getUserDetail, UserDetail } from '@chr/online-shared-microsite-core';
import { launchdarkly } from '@/common/apis/launchdarkly';

export function initialize() {
    init({ orgId: 'o-1CZ68E-na1' });
}

export async function identifyUser() {
    const userDetail: UserDetail | null = await getUserDetail();

    if (!userDetail) {
        return;
    }

    const userId = userDetail?.userId?.toString() || '';    
    const NEW_BOOKING_EXP = 'online-visibility-enable-new-bookings-experience';
    const featureFlags = await launchdarkly();
    const newVisibilityBookingsUat = featureFlags[NEW_BOOKING_EXP];    

    const userVars = {
        displayName: userId,
        companyName: userDetail.primaryBusinessLine,
        carrierCode: userDetail.primaryCustomerCode,
        userName: userDetail.primaryCustomerCode,
        newVisibilityBookingsUat: newVisibilityBookingsUat,
    };

    identify(userId, userVars);
}

export function IdentifyUser() {
    useEffect(() => {
        void identifyUser();
    }, []);

    return <></>;
}